exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/payment-securities/payment-securities-confirmation/payment-securities-confirmation.component.styl
// module id = ../../../../../src/app/master/payment-securities/payment-securities-confirmation/payment-securities-confirmation.component.styl
// module chunks = main